<template>
  <div class="">
    <!-- <div class="head-title">所有企业圈管理</div> -->
    <el-page-header
      class="page-header"
      @back="goBack"
      content="所有企业圈管理"
    >
    </el-page-header>
    <div class="Mmain">
      <nav class="navbar">
      <div class="nav-l">
        <el-button @click="tianjia()" icon="el-icon-delete" type="danger"
          >删除</el-button
        >
      </div>
      <div class="nav-r">
        <el-input
          clearable
          style="width: 35rem; margin: 0 2rem 0 2rem"
          placeholder="请输入内容搜索"
          prefix-icon="el-icon-search"
          v-model="input2"
          @change="rune()"
        >
        <el-button slot="append" type="primary" @click="rune()">查询</el-button>
        </el-input>
        
      </div>
    </nav>
    <div style="margin-top: 2rem">
      <el-table
        :data="tableData.data"
        border
        
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="createtime"
          label="时间"
          style="width: 10%"
          width="240"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="content"
          label="内容"
          style="width: 10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="url"
          label="图片/视频"
          style="width: 20%"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.type == 'image'">
              <el-image
                style="width: 5rem; height: 5rem"
                :src="scope.row.url"
                :preview-src-list="[scope.row.url]"
                fit="scale-down"
              ></el-image>
            </div>
            <div v-else>
              <video
                style="width: 7rem; height: 9rem"
                :src="scope.row.url"
                controls="controls"
              ></video>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    </div>
    <div class="paging">
      <pagination
        :total="tableData.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        :auto-scroll="false"
        @pagination="handleCurrentChange"
      />
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" label-width="8rem">
        <el-form-item label="添加" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-upload
            class="upload-demo"
            :action="`${baseURL}/api/Alioss/uploadTotal`"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="9"
            :on-exceed="handleExceed"
            :on-success="chenggong"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" label-width="8rem">
        <el-form-item label="名称" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      baseURL: this.axios.defaults.baseURL,
      fileList: [],
      url: "",
      imgs: [],
      datalist: {},
      pageSize: "1",
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.datalist = this.$route.query;
    this.userTable();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/CircleFriends/getCricleList",
          qs.stringify({
            account_id: this.tooken.account_id,
            userid: this.datalist.userid,
            content: this.input2,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.userTable();
    },
    tianjia() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请先选择朋友圈");
      } else {
        var arr = [];
        for (var a = 0; a < this.multipleSelection.length; a++) {
          arr.push(this.multipleSelection[a].id);
        }
        this.form.none = arr.toString();
        this.handleClick();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    bianji(e) {
      this.ele = e;
      this.$router.replace({
        path: "/register/user/circleFriendadd",
        query: {
          userid: e,
        },
      });
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    foren() {
      let arr = [];
      const data = new FormData();
      for (var a = 0; a <= this.fileList.length - 1; a++) {
        arr.push(this.fileList[a].file);
        data.append("file[]", this.fileList[a].file);
      }
      this.axios({
        method: "post",
        url: "/api/Alioss/uploadHost",
        data: data,
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryPHA3DHO5JQHbHVkf",
        },
      })
        .then((res) => {
          this.url = res.data.data.url.toString();
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.foren();
      this.axios
        .post(
          "/crm/CircleFriends/addCircleAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userids: this.form.none,
            url: this.url,
            content: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick() {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CircleFriends/delCircleFriends",
              qs.stringify({
                ids: this.form.none,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.userTable();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
    chenggong(response, file, fileList) {
      var arr = [];
      fileList.map((i) => {
        arr.push(i.response.data.url);
      });
      this.url = arr.toString();
    },
    handlePreview(file) {},
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  padding: 2rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.Mmain{
  background-color: #ffffff;
  border-radius: .8rem;
  
}
</style>
